export default {
  FETCH_INTERCOM_DETAILS: 'FETCH_INTERCOM_DETAILS',
};
